import { createContext, useContext } from "react";

import type { WindowInteraction } from "./Window.types";

type WindowContextValue = {
  titleId: string;
  interaction: WindowInteraction;
  maximized: boolean;
  maximizable: boolean;
  dismissible: boolean;
  startMove: (event: React.PointerEvent) => void;
  toggleMaximize: () => void;
  close: () => void;
};

export const WindowContext = createContext<WindowContextValue | null>(null);

export function useWindowContext(): WindowContextValue {
  const context = useContext(WindowContext);

  if (!context) {
    throw new Error("Window parts must be rendered inside a Window.");
  }

  return context;
}
